export default __webpack_public_path__ + "static/media/maos-telefone2.8e10b64c.png";